/*
 * @Author 彭必鲲
 * @Date 2022-04-25 14:35:51
 * @LastEditTime: 2024-04-09 10:55:26
 * @LastEditors: weixiuting weixiuting@qq.com
 * @Description
 * @FilePath \HIT_BX_INSURER_W\src\utils\request_e.js
 */
import axios from "axios";
import { message, Modal, notification } from "ant-design-vue";
import moment from "moment";
import store from "../store";
import db from "utils/localstorage";
moment.locale("zh-cn");

const CryptoJS = require("crypto-js");
const { JSEncrypt } = require("encryptlong");
let publicKey = "";
let desKey = "";
const baseURL = "";

// let toUrl = process.env.BASE_API
let toUrl = window.global_config.BASE_URL;

// 统一配置
let FEBS_REQUEST = axios.create({
  // 最新测试环境
  baseURL: baseURL,
  responseType: "json",
  timeout: 30000,
  validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200;
  },
});

// 拦截请求
FEBS_REQUEST.interceptors.request.use(
  (config) => {
    let expireTime = store.state.account.expireTime;
    let now = moment().format("YYYYMMDDHHmmss");
    // 让token早10秒种过期，提升“请重新登录”弹窗体验
    if (now - expireTime >= -10) {
      Modal.error({
        title: "登录已过期",
        content: "很抱歉，登录已过期，请重新登录",
        okText: "重新登录",
        mask: false,
        onOk: () => {
          return new Promise((resolve, reject) => {
            db.clear();
            location.reload();
          }).catch(function (reason) {
            console.log("catch:", reason);
          });
        },
      });
    }
    // 有 token就带上
    if (store.state.account.token) {
      config.headers.Authentication = store.state.account.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 拦截响应
FEBS_REQUEST.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error.response) {
      let errorMessage =
        error.response.data === null
          ? "系统内部异常，请联系网站管理员"
          : error.response.data.message;
      switch (error.response.status) {
        case 404:
          notification.error({
            message: "系统提示",
            description: "很抱歉，资源未找到",
            duration: 4,
          });
          break;
        case 403:
        case 401:
          notification.warn({
            message: "系统提示",
            description:
              "很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效",
            duration: 4,
          });
          break;
        default:
          notification.error({
            message: "系统提示",
            description: errorMessage,
            duration: 4,
          });
          break;
      }
    }
    return Promise.reject(error);
  }
);

const request = {
  async epost(url, params, options = {}, index = 0) {
    console.log("++++url", options);
    let baseUrl =
      options.baseURL != undefined && options.baseURL != null
        ? options.baseURL
        : toUrl;

    if (index > 3) {
      notification.error({
        message: "系统提示",
        description: "加密服务发生错误",
        duration: 4,
      });
      return;
    }
    const userId = Number(this.$store.state.account.user.userId);
    const accountId = Number(userId);
    const accountType = Number(1);
    const platformCode = this.$store.state.account.user.platformId;
    const headAuth = CryptoJS.SHA512(
      `${userId + accountId + accountType}${platformCode}`
    ).toString();
    if (!publicKey || !desKey) {
      console.log("baseUrl", baseUrl);
      // const keyRes = await FEBS_REQUEST.post('requestSafety/entryptionChaim', {}, {
      const keyRes = await FEBS_REQUEST.post(
        "encryption/requestSafety/entryptionChaim",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            userId: userId,
            accountId: accountId,
            accountType: accountType,
            platformCode: platformCode,
            headAuth: headAuth,
            Authentication: store.state.account.token,

            authCheckKey: "Authentication",
            authCheckMethod: "post",
            authCheckUrl: toUrl + "/api/checkToken",
          },
        }
      );
      const keyResJson = keyRes.data;
      if (keyResJson.code !== 200) {
        notification.error({
          message: "系统提示",
          description: keyResJson.msg,
          duration: 4,
        });
        return;
      }
      const keyObj = JSON.parse(keyResJson.data);
      desKey = keyObj.desKey;
      publicKey = keyObj.publicKey;
    }
    const jsEncrypt = new JSEncrypt();
    const parsePublicKey = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(publicKey),
      },
      CryptoJS.enc.Utf8.parse(desKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    jsEncrypt.setPublicKey(parsePublicKey);
    const bdata = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(JSON.stringify(params))
    ).toString();

    const data = jsEncrypt.encryptLong(bdata);
    let newUrl = baseUrl;
    //let newUrl = window.global_config.BASE_URL

    const res = await FEBS_REQUEST.post(
      `encryption/requestSafety/safetyRequest`,
      {
        data: data,
        // callUrl: `${newUrl}${url}`
        // callUrl: `https://nybxshtest.nydsju.com/api/${url}` //测试
        callUrl: `https://nybxxtsh.nydsju.com/api/${url}`, //生产 1
      },
      {
        headers: {
          "Content-Type": "application/json",
          userId: userId,
          accountId: accountId,
          accountType: accountType,
          platformCode: platformCode,
          headAuth: headAuth,
          Authentication: store.state.account.token,
          isbody: 0,

          authCheckKey: "Authentication",
          authCheckMethod: "post",
          authCheckUrl: toUrl + "/api/checkToken",
        },
      }
    );
    const resJson = res.data;
    if (resJson.code === 505) {
      publicKey = "";
      desKey = "";
      return this.$epost(url, params, options, index + 1);
    }
    if (resJson.code !== 200) {
      notification.error({
        message: "系统提示",
        description: resJson.msg,
        duration: 4,
      });
      return;
    }
    const resData = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(resJson.data),
      },
      CryptoJS.enc.Utf8.parse(desKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    const d = JSON.parse(resData);
    d.data = JSON.parse(d.data);
    return d;
  },
  async epost4(url, params, options = {}, index = 0) {
    console.log("++++url", options);
    let baseUrl =
      options.baseURL != undefined && options.baseURL != null
        ? options.baseURL
        : toUrl;

    if (index > 3) {
      notification.error({
        message: "系统提示",
        description: "加密服务发生错误",
        duration: 4,
      });
      return;
    }
    const userId = Number(this.$store.state.account.user.userId);
    const accountId = Number(userId);
    const accountType = Number(1);
    const platformCode = this.$store.state.account.user.platformId;
    const headAuth = CryptoJS.SHA512(
      `${userId + accountId + accountType}${platformCode}`
    ).toString();
    if (!publicKey || !desKey) {
      console.log("baseUrl", baseUrl);
      // const keyRes = await FEBS_REQUEST.post('requestSafety/entryptionChaim', {}, {
      const keyRes = await FEBS_REQUEST.post(
        "encryption/requestSafety/entryptionChaim",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            userId: userId,
            accountId: accountId,
            accountType: accountType,
            platformCode: platformCode,
            headAuth: headAuth,
            Authentication: store.state.account.token,

            authCheckKey: "Authentication",
            authCheckMethod: "post",
            authCheckUrl: toUrl + "/api/checkToken",
          },
        }
      );
      const keyResJson = keyRes.data;
      if (keyResJson.code !== 200) {
        notification.error({
          message: "系统提示",
          description: keyResJson.msg,
          duration: 4,
        });
        return;
      }
      const keyObj = JSON.parse(keyResJson.data);
      desKey = keyObj.desKey;
      publicKey = keyObj.publicKey;
    }
    const jsEncrypt = new JSEncrypt();
    const parsePublicKey = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(publicKey),
      },
      CryptoJS.enc.Utf8.parse(desKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    jsEncrypt.setPublicKey(parsePublicKey);
    const bdata = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(JSON.stringify(params))
    ).toString();

    const data = jsEncrypt.encryptLong(bdata);
    let newUrl = baseUrl;
    //let newUrl = window.global_config.BASE_URL

    const res = await FEBS_REQUEST.post(
      `encryption/requestSafety/safetyRequest`,
      {
        data: data,
        // callUrl: `${newUrl}${url}`
        // callUrl: `https://nybxshtest.nydsju.com/api/${url}` //测试
        callUrl: `https://nybtxtsh.nydsju.com/api/${url}`, //生产 4
      },
      {
        headers: {
          "Content-Type": "application/json",
          userId: userId,
          accountId: accountId,
          accountType: accountType,
          platformCode: platformCode,
          headAuth: headAuth,
          Authentication: store.state.account.token,
          isbody: 0,

          authCheckKey: "Authentication",
          authCheckMethod: "post",
          authCheckUrl: toUrl + "/api/checkToken",
        },
      }
    );
    const resJson = res.data;
    if (resJson.code === 505) {
      publicKey = "";
      desKey = "";
      return this.$epost4(url, params, options, index + 1);
    }
    if (resJson.code !== 200) {
      notification.error({
        message: "系统提示",
        description: resJson.msg,
        duration: 4,
      });
      return;
    }
    const resData = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(resJson.data),
      },
      CryptoJS.enc.Utf8.parse(desKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    const d = JSON.parse(resData);
    d.data = JSON.parse(d.data);
    return d;
  },
  async eget(url, options = {}, index = 0) {
    const baseUrl =
      options.baseURL != undefined && options.baseURL != null
        ? options.baseURL
        : toUrl;
    if (index > 3) {
      notification.error({
        message: "系统提示",
        description: "加密服务发生错误",
        duration: 4,
      });
      return;
    }
    const userId = Number(this.$store.state.account.user.userId);
    const accountId = Number(userId);
    const accountType = Number(1);
    const platformCode = this.$store.state.account.user.platformId;
    const headAuth = CryptoJS.SHA512(
      `${userId + accountId + accountType}${platformCode}`
    ).toString();
    if (!publicKey || !desKey) {
      // const keyRes = await FEBS_REQUEST.post('requestSafety/entryptionChaim', {}, {
      const keyRes = await FEBS_REQUEST.post(
        "encryption/requestSafety/entryptionChaim",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            userId: userId,
            accountId: accountId,
            accountType: accountType,
            platformCode: platformCode,
            headAuth: headAuth,
            Authentication: store.state.account.token,
            authCheckKey: "Authentication",
            authCheckMethod: "post",
            authCheckUrl: toUrl + "/api/checkToken",
          },
        }
      );
      const keyResJson = keyRes.data;
      if (keyResJson.code !== 200) {
        notification.error({
          message: "系统提示",
          description: keyResJson.msg,
          duration: 4,
        });
        return;
      }
      const keyObj = JSON.parse(keyResJson.data);
      desKey = keyObj.desKey;
      publicKey = keyObj.publicKey;
    }
    const jsEncrypt = new JSEncrypt();
    const parsePublicKey = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(publicKey),
      },
      CryptoJS.enc.Utf8.parse(desKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    jsEncrypt.setPublicKey(parsePublicKey);

    const res = await FEBS_REQUEST.post(
      `encryption/requestSafety/safetyRequestByGetAndUnParam`,
      {
        data: "",
        // callUrl: `${baseUrl}${url}`
        // callUrl: `https://nybxshtest.nydsju.com/api/${url}` //测试
        callUrl: `https://nybxxtsh.nydsju.com/api/${url}`, //生产 3
        // callUrl: ${url}.
      },
      {
        headers: {
          "Content-Type": "application/json",
          userId: userId,
          accountId: accountId,
          accountType: accountType,
          platformCode: platformCode,
          headAuth: headAuth,
          Authentication: store.state.account.token,
          isbody: 0,

          authCheckKey: "Authentication",
          authCheckMethod: "post",
          authCheckUrl: toUrl + "/api/checkToken",
        },
      }
    );
    const resJson = res.data;
    if (resJson.code === 505) {
      publicKey = "";
      desKey = "";
      return this.$eget(url, options, index + 1);
    }
    if (resJson.code !== 200) {
      notification.error({
        message: "系统提示",
        description: resJson.msg,
        duration: 4,
      });
      return;
    }
    const resData = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(resJson.data),
      },
      CryptoJS.enc.Utf8.parse(desKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    const d = JSON.parse(resData);
    d.data = JSON.parse(d.data);
    return d.data;
  },
};

export default request;



// WEBPACK FOOTER //
// ./src/utils/request_e.js